'use client';

import { type ComponentProps } from 'react';
import { Root, CollapsibleTrigger, CollapsibleContent } from '@radix-ui/react-collapsible';

function Collapsible({
    defaultOpen,
    open,
    disabled,
    asChild,
    ref,
    ...props
}: ComponentProps<typeof Root>) {
    return (
        <Root
            data-slot="collapsible"
            asChild={asChild}
            defaultOpen={defaultOpen}
            open={open}
            disabled={disabled}
            ref={ref}
            {...props}
        />
    );
}

function CollapsibleButton({ asChild, ref, ...props }: ComponentProps<typeof CollapsibleTrigger>) {
    return (
        <CollapsibleTrigger
            data-slot="collapsible-trigger"
            asChild={asChild}
            ref={ref}
            {...props}
        />
    );
}

function CollapsiblePanel({
    forceMount,
    asChild,
    ref,
    ...props
}: ComponentProps<typeof CollapsibleContent>) {
    return (
        <CollapsibleContent
            forceMount={forceMount}
            asChild={asChild}
            data-slot="collapsible-content"
            ref={ref}
            {...props}
        />
    );
}

export { Collapsible, CollapsibleButton, CollapsiblePanel };
